import React,{Suspense} from 'react';
import Block from '../../adapters/helpers/Block';
import PropTypes from 'prop-types'
import { mediaQueryHOC } from '../../adapters/helpers/Hooks'
import { UserQuoteConstants } from '../../adapters/helpers/Constants';
import {Label} from '../Label/Label';
import dynamic from 'next/dynamic';
const Image = dynamic(() => import('../Image/Image'));
const Heading = dynamic(() => import('../Heading/Heading'));
const StarRating = dynamic(() => import('../StarRating/StarRating'));
const CustomerReview = dynamic(() => import('../CustomerReviews/CustomerReview'));
const Disclaimer = dynamic(() => import('../Disclaimer/Disclaimer'));
import Loader from '../../adapters/helpers/Loader';

function UserQuote(props) {
    const {extraAttributes, isMedium} = props;
    return (extraAttributes && extraAttributes.entity) ?
        renderUserQuoteBlock(extraAttributes.entity, props, isMedium) :
        '';
}

export default mediaQueryHOC(UserQuote);

function renderUserQuoteBlock(entity, props) {

    const product = entity;
    const productOverview = new Block(entity.productOverview);
    const propsBlock = new Block(props);

    const classNames = propsBlock.getFieldValue(UserQuoteConstants.classNames);
    const title = propsBlock.getFieldValue(UserQuoteConstants.title);
    const anchorId = propsBlock.getAnchorId();
    const mainAsset = productOverview.getFieldValue(UserQuoteConstants.mainAsset);
    const productName = productOverview.getFieldValue(UserQuoteConstants.name);
    const disclaimer = productOverview.getFieldValue(UserQuoteConstants.disclaimer);
    const writeAReviewLabel = Label({label: propsBlock.getFieldValue(UserQuoteConstants.writeAReviewLabel)});
    const userQuote = entity.featuredQuote;

    let authorName;
    let quote;
    let starRating;
    let displayUserReviews;

    if(userQuote) {
        authorName = userQuote.fields.authorName;
        quote = userQuote.fields.quote;
        starRating = userQuote.fields.starRating;
        displayUserReviews = userQuote.fields.displayUserReviews;
    }

    //User reviews are displayed by default if there is no featured quote
    if(displayUserReviews == undefined){
        displayUserReviews = true;
    }

    return (

        <Suspense fallback={<Loader />}>
        <div className={`ob-user-quote ${classNames ? classNames : ''}`} id={anchorId} >
            <div className='ob-user-quote_wrapper'>
                {userQuote &&
                    <div className='ob-user-quote_featured-quote-wrapper'>
                        <Suspense fallback={<Loader />}>
                        <Heading className='ob-user-quote_heading' tag={UserQuoteConstants.h2}>
                            {title}
                        </Heading>
                        </Suspense>
                        <div className='ob-user-quote_flex-container'>
                            <div className='ob-user-quote_flex-container-col'>
                                <div className='ob-user-quote_star-rating'>
                                    {props.isMedium ? (
                                        <StarRating ratingNumber={starRating}/>
                                    ) : (
                                        <StarRating ratingNumber={starRating} smallSize={5.2} mediumSize={7.2}
                                                    largeSize={9.2}/>
                                    )}
                                </div>

                                <div className='ob-user-quote_quote'>
                                    {quote}
                                </div>

                                <div className='ob-user-quote_author-name'>{authorName}</div>
                            </div>
                            <div className='ob-user-quote_flex-container-col'>
                            <Suspense fallback={<Loader />}>
                                <Image image={mainAsset} className='ob-user-quote_image'></Image>
                            </Suspense>
                            </div>
                        </div>
                        {disclaimer &&
                            <Suspense fallback={<Loader />}><Disclaimer document={disclaimer} /></Suspense>
                        }
                    </div>
                }

                <Suspense fallback={<Loader />}>
                <CustomerReview
                    product={product}
                    productName={productName}
                    isDisplay={displayUserReviews}
                    title={writeAReviewLabel}/>
                </Suspense>

            </div>
        </div>
        </Suspense>

    )
}

renderUserQuoteBlock.propTypes = {
    isMedium: PropTypes.bool,
}
